'use client';

import Icon from '@/components/ui/AppIcon';

interface AppStoreButtonsProps {
  variant?: 'default' | 'compact';
  className?: string;
}

const AppStoreButtons = ({ variant = 'default', className = '' }: AppStoreButtonsProps) => {
  const handleDownload = (platform: 'ios' | 'android') => {
    const urls = {
      ios: 'https://apps.apple.com/signaly',
      android: 'https://play.google.com/store/apps/signaly'
    };
    window.open(urls[platform], '_blank');
  };

  if (variant === 'compact') {
    return (
      <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
        <button
          onClick={() => handleDownload('ios')}
          className="flex items-center justify-center space-x-2 px-4 py-2 bg-foreground text-background rounded-lg hover:scale-105 transition-all duration-200 shadow-md"
          aria-label="Download on the App Store"
        >
          <Icon name="DevicePhoneMobileIcon" size={20} />
          <div className="text-left">
            <div className="text-xs opacity-80">Download on</div>
            <div className="text-sm font-heading font-semibold">App Store</div>
          </div>
        </button>

        <button
          onClick={() => handleDownload('android')}
          className="flex items-center justify-center space-x-2 px-4 py-2 bg-foreground text-background rounded-lg hover:scale-105 transition-all duration-200 shadow-md"
          aria-label="Get it on Google Play"
        >
          <Icon name="DevicePhoneMobileIcon" size={20} />
          <div className="text-left">
            <div className="text-xs opacity-80">Get it on</div>
            <div className="text-sm font-heading font-semibold">Google Play</div>
          </div>
        </button>
      </div>
    );
  }

  return (
    <div className={`flex flex-col sm:flex-row gap-4 ${className}`}>
      <button
        onClick={() => handleDownload('ios')}
        className="flex items-center justify-center space-x-3 px-8 py-4 bg-foreground text-background rounded-xl hover:scale-105 transition-all duration-200 shadow-lg"
        aria-label="Download on the App Store"
      >
        <Icon name="DevicePhoneMobileIcon" size={24} />
        <div className="text-left">
          <div className="text-xs opacity-80">Download on the</div>
          <div className="text-lg font-heading font-semibold">App Store</div>
        </div>
      </button>

      <button
        onClick={() => handleDownload('android')}
        className="flex items-center justify-center space-x-3 px-8 py-4 bg-foreground text-background rounded-xl hover:scale-105 transition-all duration-200 shadow-lg"
        aria-label="Get it on Google Play"
      >
        <Icon name="DevicePhoneMobileIcon" size={24} />
        <div className="text-left">
          <div className="text-xs opacity-80">Get it on</div>
          <div className="text-lg font-heading font-semibold">Google Play</div>
        </div>
      </button>
    </div>
  );
};

export default AppStoreButtons;